<div class="intl-phone-field">
    <label [attr.for]="inputId" class="mb-1.5 block text-sm font-medium">
        {{ label }}<span *ngIf="required" class="font-semibold text-red-600" aria-hidden="true"> *</span>
    </label>
    <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-2">
        <div class="flex shrink-0 sm:w-[min(100%,7rem)]">
            <select
                class="intl-phone-field__country form-select w-full rounded-lg border-white-light py-2 text-sm leading-snug dark:border-[#191e3a] dark:bg-dark"
                [id]="inputId + '-country'"
                [name]="name + 'Country'"
                [ngModel]="countryIso"
                (ngModelChange)="onCountryIsoChange($event)"
                [disabled]="disabled"
                [attr.aria-label]="label + ' country code'"
            >
                <!-- The name is in the option text, not only the title: a tooltip is no help
                     when scanning 200-odd entries, and +1 alone does not say which country. -->
                <option *ngFor="let o of countryOptions" [value]="o.iso" [title]="o.label">
                    {{ o.flag }} {{ o.dial }} · {{ o.label }}
                </option>
            </select>
        </div>
        <div class="min-w-0 flex-1">
            <input
                #nationalInput
                [id]="inputId"
                type="tel"
                [name]="name"
                [ngModel]="nationalNumber"
                (ngModelChange)="onNationalChange($event, nationalInput)"
                (keydown)="onNationalKeydown($event)"
                (blur)="onNationalBlur()"
                [disabled]="disabled"
                [placeholder]="placeholder"
                autocomplete="tel"
                inputmode="tel"
                [attr.aria-required]="required ? 'true' : null"
                class="intl-phone-field__national form-input w-full rounded-lg"
            />
            <p *ngIf="fieldError" class="mt-1 text-xs text-red-600 dark:text-red-400">{{ fieldError }}</p>
        </div>
    </div>
</div>
